export default "__VITE_ASSET__Bkc9ov7K__"